import type { ColumnsType } from 'antd/es/table';
import { Button, Popconfirm, Space, Dropdown, Modal } from 'antd';
import { LineChartOutlined, EditOutlined, DeleteOutlined, MoreOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Vehicle } from '../../types';

interface VehicleColumnsProps {
  t: (key: string) => string;
  onEdit: (vehicle: Vehicle) => void;
  onDelete: (id: number) => void;
  onViewEfficiency: (vehicle: Vehicle) => void;
}

export const getVehicleDesktopColumns = ({
  t,
  onEdit,
  onDelete,
  onViewEfficiency
}: VehicleColumnsProps): ColumnsType<Vehicle> => [
  {
    title: t('license.plate'),
    dataIndex: 'licensePlate',
    key: 'licensePlate',
    sorter: (a, b) => a.licensePlate.localeCompare(b.licensePlate)
  },
  {
    title: t('brand'),
    dataIndex: 'brand',
    key: 'brand',
    sorter: (a, b) => a.brand.localeCompare(b.brand)
  },
  {
    title: t('model'),
    dataIndex: 'model',
    key: 'model'
  },
  {
    title: t('year'),
    dataIndex: 'year',
    key: 'year',
    sorter: (a, b) => (a.year || 0) - (b.year || 0)
  },
  {
    title: t('color'),
    dataIndex: 'color',
    key: 'color'
  },
  {
    title: t('capacity.tons'),
  dataIndex: 'capacityTons',
    key: 'capacityTons',
    render: (value) => value ? `${value} tons` : '-'
  },
  {
    title: t('fuel.tank.capacity'),
    dataIndex: 'fuelTankCapacity',
    key: 'fuelTankCapacity',
    render: (value) => value ? `${value}L` : '-'
  },
  {
    title: t('created.by'),
    dataIndex: 'createdByUserName',
    key: 'createdByUserName'
  },
  {
    title: t('actions'),
    key: 'actions',
    render: (_, record) => (
      <Space>
<Button
          icon={<LineChartOutlined />}
     onClick={() => onViewEfficiency(record)}
       size="small"
          type="link"
       title={t('view.fuel.efficiency')}
        />
    <Button
          icon={<EditOutlined />}
      onClick={() => onEdit(record)}
     size="small"
        />
 <Popconfirm
        title={t('delete.confirm')}
          onConfirm={() => onDelete(record.id)}
          okText={t('yes')}
          cancelText={t('no')}
    >
    <Button
            icon={<DeleteOutlined />}
     danger
   size="small"
          />
        </Popconfirm>
      </Space>
    )
  }
];

export const getVehicleMobileColumns = ({
  t,
  onEdit,
  onDelete,
  onViewEfficiency
}: VehicleColumnsProps): ColumnsType<Vehicle> => [
  {
  title: t('vehicle'),
    dataIndex: 'licensePlate',
    key: 'licensePlate',
    width: '50%',
    render: (plate, record) => (
      <div>
    <strong style={{ fontSize: '14px' }}>{plate}</strong>
    <div style={{ fontSize: '11px', color: '#666' }}>
   {record.brand} {record.model}
        </div>
        {record.capacityTons && (
     <div style={{ fontSize: '10px', color: '#1890ff' }}>
       {record.capacityTons} tons
  </div>
    )}
      </div>
    )
  },
  {
    title: t('details'),
    key: 'details',
    width: '30%',
    render: (_, record) => (
  <div style={{ fontSize: '11px' }}>
   {record.year && <div>{record.year}</div>}
        {record.color && <div>{record.color}</div>}
        {record.fuelTankCapacity && (
          <div style={{ color: '#666' }}>⛽ {record.fuelTankCapacity}L</div>
        )}
</div>
    )
  },
  {
    title: t('actions'),
    key: 'actions',
    width: '20%',
    render: (_, record) => {
      const handleDelete = () => {
    Modal.confirm({
          title: t('delete.confirm'),
      icon: <ExclamationCircleOutlined />,
   okText: t('yes'),
     cancelText: t('no'),
  okType: 'danger',
  onOk: () => onDelete(record.id)
     });
 };

      return (
      <Space size={4} wrap>
          <Button
     icon={<LineChartOutlined />}
     onClick={() => onViewEfficiency(record)}
            size="small"
            type="text"
        title={t('view.fuel.efficiency')}
          />
        <Button
icon={<EditOutlined />}
   onClick={() => onEdit(record)}
     size="small"
            type="text"
          />
       <Button
      icon={<DeleteOutlined />}
          onClick={handleDelete}
       size="small"
            type="text"
    danger
      />
 </Space>
      );
    }
  }
];
